import { useHistory, useLocation } from 'react-router-dom';
import { getBaseCanonicalUrl } from '~/helpers/baseCanonicalUrl';

/**
 * Absolute canonical URL for a router pathname (defaults to the current one).
 *
 * `useLocation().pathname` never includes the router basename, and on
 * localized sites the basename is the locale path segment (e.g. `/en` for
 * en-SE on kvd.se). Building canonicals straight from the pathname therefore
 * drops the locale prefix and points at a 404. `history.createHref` re-adds
 * the basename on both server (StaticRouter) and client (BrowserRouter).
 */
const useCanonicalUrl = (pathname?: string) => {
  const history = useHistory();
  const location = useLocation();

  return getBaseCanonicalUrl(
    history.createHref({ pathname: pathname ?? location.pathname })
  );
};

export default useCanonicalUrl;
